import { Button, EmptyState } from '@buffer-mono/popcorn'

import styles from './GlobalEmptyState.module.css'

import type { JSX } from 'react'

type GlobalEmptyStateProps = {
  imageSrc: string
  altText: string
  header: string
  description: string | JSX.Element
  secondaryAction?: {
    onClick: () => void
    label: string
  } | null
  primaryAction?: {
    onClick: () => void
    label: string
  } | null
  textAction?: {
    onClick: () => void
    label: string
  } | null
  height?: string | null
}

export default function GlobalEmptyState({
  imageSrc,
  altText,
  header,
  description,
  secondaryAction = null,
  primaryAction = null,
  textAction = null,
  height = null,
}: GlobalEmptyStateProps): JSX.Element {
  return (
    <div className={styles.wrapper} style={{ height: height ?? undefined }}>
      <EmptyState>
        <EmptyState.Illustration src={imageSrc} alt={altText} />
        <EmptyState.Heading>{header}</EmptyState.Heading>
        <EmptyState.Description>{description}</EmptyState.Description>
        <div className={styles.ctaWrapper}>
          {secondaryAction && (
            <Button variant="secondary" onClick={secondaryAction.onClick}>
              {secondaryAction.label}
            </Button>
          )}
          {primaryAction && (
            <Button variant="primary" onClick={primaryAction.onClick}>
              {primaryAction.label}
            </Button>
          )}
          {textAction && (
            <Button variant="tertiary" onClick={textAction.onClick}>
              {textAction.label}
            </Button>
          )}
        </div>
      </EmptyState>
    </div>
  )
}
